import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../features/Auth/authSlice";
import surnameReducer from "../features/Surname/surname.slice";
import userReducer from "../features/User/user.slice";
import categoryReducer from "../features/Category/category.slice";
import categoryDataReducer from "../features/CategoryData/CategoryData.slice";
import bloodGroupDataReducer from "../features/BloodGroup/bloodGroup.slice";
import photogalleryDataReducer from "../features/PhotoGallery/PhotoGallery.slice";
import videoDataReducer from "../features/Video/Video.slice";
import contactReducer from "../features/ContactUs/contactSlice";
import dashboardReducer from "../features/DataCount/dataCount.slice";
import notificationReducer from "../features/Notification/Notification.slice";
import communityCategoryReducer from "../features/CommunityCategory/communityCategory.slice";
import commityMemberReducer from "../features/CommityMember/CommityMember.slice";
import donorCategoryReducer from "../features/Donor Categopry/Donor.slice";
import donorMemberReducer from "../features/DonorMember/DonorMember.slice";
import advertisementReducer from "../features/Advertisement/Advertisement.slice";
import galleryCategoryReducer from "../features/PhotoGalleryCategory/PhotoGalleryCategory.slice";
import videoCategoryReducer from "../features/VideoCategory/VideoCategory.slice";
import resultCategoryReducer from "../features/ResultCategory/ResultCategory.slice";
import resultReducer from "../features/Result/Result.slice";
import userRequestReducer from "../features/User/user.slice copy";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    surname: surnameReducer,
    user: userReducer,
    category: categoryReducer,
    categoryData: categoryDataReducer,
    bloodGroupData: bloodGroupDataReducer,
    photogalleryData: photogalleryDataReducer,
    galleryCategory: galleryCategoryReducer,
    videoData: videoDataReducer,
    videoCategory: videoCategoryReducer,
    conatct: contactReducer,
    dashboard: dashboardReducer,
    notification: notificationReducer,
    communityCategory: communityCategoryReducer,
    commityMember: commityMemberReducer,
    donorCategory: donorCategoryReducer,
    donorMember: donorMemberReducer,
    advertisement: advertisementReducer,
    resultCategory: resultCategoryReducer,
    result: resultReducer,
    userRequest: userRequestReducer,
  },
});
